module.exports = __webpack_public_path__ + "img/Washing.58be5dc2.svg";